export default __webpack_public_path__ + "static/media/font.d58fc19c.svg";